<template>
  <div @click="showSearchJob=false">
    <div class="searchContainer">

      <div class="flex">

        <!-- 列表 -->
        <div class="talentPage flex1-nohide" style="width: 100%">
          <skeleton :skeletonType="'resumeList'" v-if="isLoading" class="mt16"></skeleton>
          <talentList v-else ref="talentList" @pageChange="pageChange" :isLoading="isLoading" :isFirstQuery="isFirstQuery" :isSearchData="true" @getDetail="getDetail" :recommendTagVisible="recommendTagVisible" />
        </div>

      </div>

      <!-- 简历详情 -->
      <resume-detail-box ref="resumeDetailBox" @getDetail="getDetail" :notfindResume="notfindResume"  @hideDetails="hideDetails" :favoritesId="favoritesId" v-if="showDetail"/>
      
      <!-- 完善信息弹层 -->
      <userinfo-tips @confirmToRecruitInfos="hideDetails" />


    </div>
  </div>
</template>

<script>
import talentList from '../talenteList/Index'
import ResumeDetailBox from '@/components/resumeDetailBox/index'
import userinfoTips from '@/components/block/userinfoTips'
import { isitRedundant, isToggleUser, checkUserState, get_tUser, toLogin, updateJWT } from '@/utils/utils';
import { headImgList } from '@/utils/static'
import { queryFilter, checkCity } from '@/views/talent/search/ListFilter'
import skeleton from '@/components/skeletonDiagram/index.vue'
// 所有接口
import actions from '@/actions/index'
// 搜索的mixins
import searchMixins from '@/mixins/search/config' 

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    recommendTagVisible: {
      type: Boolean,
      default: false
    },
    searchData: {
      type: Object,
      default: function () {
        return  {
          keyword: '', // 关键词 用户输入
          city: '全国', // 城市 单选
          degree: [], // 学历 多选
          school: [], // 院校 多选
          experience: [] // 工作经验 多选
        }
      }
    }
  },
  mixins:[searchMixins],
  data(){
    return {
      userJWT:{},
      userInfo:{},
      cityIndex:'',
      searchVal:'', //搜索框value
      isComposing:false, //搜索框值，仅做监听

      pageNo:1, //当前第几页
      pageSize:15,//每页15条数据

      latest:0,//查看最新简历，0，1 选中和取消

      city:'全国', //当前选择的城市
      keywords:[], //当前选择的keyword
      selectedEducation:[], //学历选中数据
      selectedSchool:[],  //学校选中数据
      selectedeXperience:[], //经验选中数据

      isLoading:true,//是否在请求列表
      isQueryEnd:true,//是否请求完毕
      isFirstQuery:true,//是否是第一次请求

      showDetail:false,

      searchHistory:[],//搜索历史
      keyword_hit:[], //单个简历的高亮数据

      job_id:'',//匹配的职位id
      searchPositionIndex: -1,//左侧搜索上点击的第几个
      favoritesId:'', //是否自动收藏
      notfindResume:false,//是否未找到简历
      headImgList: headImgList,
      userTokenNumber:0,
      scrollHeaderHeight:0, //获取搜索框高度
      scrollTopNumber:0,//每次滚动多少

      showSearchJob: false, //是否显示搜索框里边的职位
      showSearchJobScrollHeight: 0, //显示时的高度
      jobType:{
        '大专':'专科,本科,硕士,博士,MBA',
        '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },

    }
  },
  computed:{
    ...mapState('block',['userInfoState', 'bodyClientHeight', 'windowScrollTop', 'windowInnerHeight', 'jobsPopUpsState']),
    ...mapState('resumeDetails',['resumeDetailToken', 'resumeListObj', 'resumeDetail', 'resumeDetailOptions', 'myPosition', 'listOptions', 'searchListObj', 'listPageNumber']),
  },
  components:{
    talentList,
    ResumeDetailBox,
    'userinfo-tips':userinfoTips,
    skeleton
  },
  async created(){
    this.userJWT = get_tUser();

    this.updateRoutePageName('talentSearchList');
    this.created();
    if(this.userJWT.t){
      // 获取职位列表
      this.getMyPosition();
    }
  },
  methods:{
    ...mapMutations('headerOption', ['updateHeaderTitle', 'updateHeaderTitleVisible']),
    ...mapMutations('block',['toggleUserInfoState','updateSharePage','updagreBodyClient', 'updateBlockStateFun']),
    ...mapMutations('resumeDetails',['updateRoutePageName', 'updateResumeDetailToken', 'updateResumeListObj', 'resetResumeListObj', 'updateResumeDetail', 'updateListOptions', 'updateSearchListObj','updateDownloadResumeInfo', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapActions('resumeDetails',['getMyPosition']),
  
    // 同顶部created
    async created () {

      // 获取订阅列表
      try {
        let params = {
          page: 1,
          size: 20
        }
        let res = await actions.resumes.get_subscribe_list(params)
        if (res.code === 1000) {
          if (res.data && res.data.length) {
            let item = res.data[0]
            
            this.keywords = item.keyword.split(' ')
            this.city = item.expected_location
            this.selectedEducation = item.degree ? item.degree.split(',') : []
            this.selectedSchool = item.school_tags ? item.school_tags.split(',') : []
            this.selectedeXperience = item.experiences ? item.experiences.split(',') : []

            //获取搜索列表
            this.getList()
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    //获取简历列表
    async getList(){

      //增加历史记录
      // this.addHistory();

      //未完成不允许加载
      if(!this.isQueryEnd){
        return false;
      }
      let queryLoading = null;
      if(!this.isFirstQuery){
        queryLoading =  this.$message({
          message: '正在加载...',
          iconClass:'el-icon-loading',
          duration:0,
        });
      }else{
        //返回顶部
        scrollTo(0,0);
        this.showSearchJob = false;
      }

      // {'海外QS前100', '211', '类211', '985', '一流大学建设高校B类', '一流大学建设高校A类', '一流学科建设高校'}
      let school_tags = ''
      if(this.selectedSchool.length == 1){
        school_tags =  this.selectedSchool[0]==='985/211' ? '211,类211,985,一流大学建设高校B类,一流大学建设高校A类,一流学科建设高校' : '海外QS前100'
      }else if(this.selectedSchool.length == 2){
        school_tags =  '211,类211,985,一流大学建设高校B类,一流大学建设高校A类,一流学科建设高校,海外QS前100'
      }

      let queryData = {
        keyword:this.keywords.join(' '), //搜索关键词
        from:(this.pageNo-1) * this.pageSize, //起始数据
        size:this.pageSize, //每页条数
        experiences: this.selectedeXperience.join(','), //工作经验 多个则用,隔开
        degree: this.selectedEducation.join(','), //学历
        school_tags, //学校
        latest:this.latest, //是否最新
        expected_location:this.city === '全国' ? '' : this.city,
        platform: 'pc_browser',
        subscribe_cv: true
      }

      //更新请求状态
      this.isQueryEnd = false;
      this.isLoading = true;
      //请求列表
      // actions.resumes.getResumes(queryData).then(res=>{
      actions.resumes.newGetResumes(queryData).then(res=>{
        this.isLoading = false;
        if(!this.isFirstQuery && queryLoading){
          queryLoading.close();
        }
        //更新当前路由名字
        this.updateRoutePageName('talentSearchList');
        
        if(res.code ===1000){
          let { resumes } = res.data;
          let tokenIndex = -1;
          //方便读取当前第几个
          let resumeIndex = -1;

          let tokenList = []
          resumes.forEach((item, index) => {
            tokenList.push(item.resume._source.token)
          })
          // 先加载列表数据，获取简历各个状态之后再修改一次列表数据
          //如果是进入时就有token
          if(this.resumeDetailToken){
            resumes.forEach((item,index)=>{
              if(this.favoritesId == item.resume._source.token){
                tokenIndex = index
              }
              //同步当前是第几个元素
              if(this.resumeDetailToken == item.resume._source.token){
                resumeIndex = index
              }
            })
          }

          //判断是下一页
          let isNextPage = false;
          if(this.listPageNumber > this.listOptions.page){
            //同步顶部详情token
            this.updateResumeDetailToken(resumes[0].resume._source.token);
            resumeIndex = this.listOptions.resumeIndex;
            this.isNextPage = true;
          }

          let resumeListObj = JSON.parse(JSON.stringify(this.resumeListObj))
          let nowResumeList = this.pageNo === 1 ? [] : resumeListObj.searchList;
          let resumeList = nowResumeList.concat(resumes);
          //合并列表
          // resumeListObj.searchList = res.data.resumes;
          this.pageNo === 1 && this.updateResumeListObj({key:'searchList', value: resumeList});

          //更新搜索参数到vuex
          this.updateSearchListObj({
            ...this.searchListObj,
            keyword_seg: res.data.keyword_seg || [], //列表分词数据
          })

          if(this.favoritesId){
            this.$refs.talentList.resumeCollect("",tokenIndex,this.favoritesId);
            this.favoritesId = '';
          }
          //列表数据同不到vuex
          this.updateListOptions({
            resumeIndex,
            page: this.pageNo,
            page_size: this.pageSize,
            total_count: res.data.total_count,
          });

          //如果有简历token，自动弹出token
          if(this.resumeDetailToken){
            this.getDetail({token:this.resumeDetailToken, isNextPage: this.isNextPage, item: resumeListObj.searchList[resumeIndex]});
          }
          if(this.isFirstQuery){
            //返回顶部
            scrollTo(0,0);
          }
          setTimeout(() => {
            //获取body高度
            this.getBodyClient();
            this.isFirstQuery = false;
            this.isQueryEnd = true;
          }, 10);
          actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
            if (detailRes.code === 1000) {
              let { data } = detailRes
              let newResumes = resumes.map((item, index) => {
                return {...item, ...data[index]}
              })
              //如果是进入时就有token
              if(this.resumeDetailToken){
                resumes.forEach((item,index)=>{
                  if(this.favoritesId == item.resume._source.token){
                    tokenIndex = index
                  }
                  //同步当前是第几个元素
                  if(this.resumeDetailToken == item.resume._source.token){
                    resumeIndex = index
                  }
                })
              }

              //判断是下一页
              let isNextPage = false;
              if(this.listPageNumber > this.listOptions.page){
                //同步顶部详情token
                this.updateResumeDetailToken(newResumes[0].resume._source.token);
                resumeIndex = this.listOptions.resumeIndex;
                this.isNextPage = true;
              }

              let resumeListObj = JSON.parse(JSON.stringify(this.resumeListObj))
              let nowResumeList = this.pageNo === 1 ? [] : resumeListObj.searchList;
              let resumeList = nowResumeList.concat(newResumes);
              //合并列表
              // resumeListObj.searchList = res.data.resumes;
              this.updateResumeListObj({key:'searchList', value: resumeList});

              //更新搜索参数到vuex
              this.updateSearchListObj({
                ...this.searchListObj,
                keyword_seg: res.data.keyword_seg || [], //列表分词数据
              })

              if(this.favoritesId){
                this.$refs.talentList.resumeCollect("",tokenIndex,this.favoritesId);
                this.favoritesId = '';
              }
              //列表数据同不到vuex
              this.updateListOptions({
                resumeIndex,
                page: this.pageNo,
                page_size: this.pageSize,
                total_count: res.data.total_count,
              });

              //如果有简历token，自动弹出token
              if(this.resumeDetailToken){
                this.getDetail({token:this.resumeDetailToken, isNextPage: this.isNextPage, item: resumeListObj.searchList[resumeIndex]});
              }
              if(this.isFirstQuery){
                //返回顶部
                scrollTo(0,0);
              }
              setTimeout(() => {
                //获取body高度
                this.getBodyClient();
                this.isFirstQuery = false;
                this.isQueryEnd = true;
              }, 10);
            }
          })
        }else{
          //接口失败，取消loading状态
          this.isFirstQuery = false;
          this.isQueryEnd = true;
          queryLoading && queryLoading.close();
        }
      })
    },
    pageChange(pageNo){
      //修改分页条数
      this.pageNo = pageNo;
      //获取列表数据
      this.getList();
    },
    // 左侧方法
    //切换是否查看最新简历
    checkLatest(){
      this.latest = this.latest ? 0 : 1;
      //重置参数，请求接口
      this.resetQuery();
    },
    //获取简历详情
    async getDetail(options){
      // 将列表简历的基本信息存入vuex
      if (options.item) {
        this.updateSearchResumeBasic(options.item)
        this.updateDownloadResumeInfo(options.item)
      }
      //更新搜索参数到vuex
      this.updateSearchListObj({
        ...this.searchListObj,
        keyword_hit: options.keyword_hit || [], //列表搜索关键词数据
      })

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          this.pageChange(1);
          return false;
        },
      });
      let user = get_tUser();
      if(user.h_t){
        //获取职位列表
        this.getMyPosition({job_id: this.job_id});
      }
      // 显示骨架图loading
      this.updateShowDetailFlag(false)
      this.showDetail = true;
      actions.resume_permissions.v2resumedetails({token: options.token}).then(res=>{
        if(res.code === 80139 || res.code === 80120 || res.code === 1000 || res.code === 80121){
          // 如果是翻页，需要同步当前第几个
          if(options.type=== 'prev' || options.type==='next' || options.isNextPage){
            let resumeIndex = options.type==='next' || options.isNextPage ? this.listOptions.resumeIndex+1 : this.listOptions.resumeIndex-1;
            //同步分页数据
            this.updateListOptions({
              ...this.listOptions,
              resumeIndex: resumeIndex,
            });
          }
        }
        if(res.code === 80139 || res.code === 80120 || res.code === 80121){
          this.notfindResume = true;
          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
          return false;
        }
        this.notfindResume = false;
        if(res.code === 1000){
          //数据同步到vuex中
          this.updateResumeDetail(res.data);
          this.$refs.resumeDetailBox && this.$refs.resumeDetailBox.highlightFunc()
          //简历详情相关url 及 参数，用作收藏等交互 
          this.updateResumeDetailToken(options.token);

          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
      
    },
    //隐藏详情
    hideDetails(){
      this.showDetail = false;

      //重置详情的token相关数据
      this.updateResumeDetailToken('');

      // 页面结构排序
      this.sections_position = [];
      // 其他排序
      this.others_position = [];
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },
    //重置参数，请求接口
    resetQuery(){
      this.pageNo = 1;
      //重置列表数据
      this.resetResumeListObj();
 
      this.isLoading = true;//是否在请求列表
      this.isQueryEnd = true;//是否请求完毕
      this.isFirstQuery = true;//是否是第一次请求
      
      this.getList();
      //重置左侧职位选中index
      this.searchPositionIndex = -1;
    },
    //增加历史记录
    addHistory(){
      let keywords = this.keywordsBat.join(' ');
      //判断当前搜索项以前搜索过没有
      let haskeyword = this.searchHistory.filter((item) => {
        return item.name === keywords;
      })
      if (!haskeyword.length) {
        //搜索记录最前边，增加一条记录
        this.searchHistory.unshift({
          name:keywords,
          keywords:[...this.keywordsBat],
        });
        this.searchHistory.length = this.searchHistory.length>10 ? 10 : this.searchHistory.length;
        //更新到本地
        localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
      }
    },
    //获取body高度
    getBodyClient(){
      this.updagreBodyClient(document.body.clientHeight);
    },
    scrollTop(){
      if(!this.scrollTopNumber){
        this.scrollTopNumber = document.documentElement.scrollTop/10
      };
      //参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop-=this.scrollTopNumber;
      if (document.documentElement.scrollTop>0) {
        var c=setTimeout(()=>this.scrollTop(this.scrollTopNumber),16);
      }else {
        this.scrollTopNumber = 0
        clearTimeout(c);
      }
      // scrollTo(0,0)
    }

  },
  watch: {
    windowScrollTop(val, oldVal){
      // // body高度 - 浏览器窗口高度
      let maxScrollTop = this.bodyClientHeight-this.windowInnerHeight;
      let maxPage = Math.ceil(this.listOptions.total_count/15)
      //监控 顶部头高度，控制左侧搜索框高度

      if(this.windowScrollTop - this.showSearchJobScrollHeight >= 100 && this.showSearchJob){
        this.showSearchJob = false;
      }
      if(maxScrollTop-val<250 && this.isQueryEnd && !this.isLoading && this.pageNo<maxPage){
        this.pageNo = this.pageNo+1;
        this.getList();
      }
    },
    //监听分页变化
    listPageNumber:{
      handler: function (val, oldVal) {
        // 翻上一页 || 下一页
        if(val < this.listOptions.page || val > this.listOptions.page){
          this.pageChange(this.listPageNumber)
        }
      },
      deep: true
    },
    // 监听传入参数变化
    searchData: {
      handler: function (val) {
        this.keywords = val.keyword.split(' ')
        this.city = val.city
        this.selectedEducation = val.degree
        this.selectedSchool = val.school
        this.selectedeXperience = val.experience

        // 重置页数
        this.pageNo = 1;
        //重置列表数据
        // this.resetResumeListObj();
        this.getList()
      },
      deep: true
    }
  },

}
</script>
<style lang="scss" scoped>
@import './Index.scss';
</style>